import React, { useEffect, useState } from "react";
import { API_URL } from "../../../../constants";
import TrainingCalenderfol from "./TrainingCalenderfol";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { format, startOfMonth, endOfMonth } from 'date-fns';
import { FaSpinner } from "react-icons/fa"; // Import the spinner icon

const TrainingCalender = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Training Calendar"));
  }, []);
  
  // Initialize with current month's range
  const [dateRange, setDateRange] = useState(() => {
    const now = new Date();
    return {
      start: format(startOfMonth(now), 'yyyy-MM-dd'),
      end: format(endOfMonth(now), 'yyyy-MM-dd')
    };
  });

  const [trainerData, setTrainerData] = useState([]);
  const [eventData, setEventData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleDatesChange = ({ start, end }) => {      
    const formattedStart = format(start, 'yyyy-MM-dd');
    const formattedEnd = format(end, 'yyyy-MM-dd');
    setDateRange({ start: formattedStart, end: formattedEnd });
  };

  useEffect(() => {
    fetchTrainingData();
  }, [dateRange.start, dateRange.end]);

  const fetchTrainingData = async () => {
    try {
      setLoading(true);
      setError(null);

      const [trainersResponse, trainingsResponse] = await Promise.all([
        GetServiceCaller(
          `${API_URL}projectmanagement/reports/4?P_DSType=trainers&P_FromDate=${dateRange.start}&P_ToDate=${dateRange.end}`
        ),
        GetServiceCaller(
          `${API_URL}projectmanagement/reports/4?P_DSType=trainings&P_FromDate=${dateRange.start}&P_ToDate=${dateRange.end}`
        )
      ]);

      if (trainersResponse?.status === 200 && trainingsResponse?.status === 200) {
        const trainersData = trainersResponse.data?.data || trainersResponse.data;
        const trainingsData = trainingsResponse.data?.data || trainingsResponse.data;
        
        setTrainerData(Array.isArray(trainersData) ? trainersData.map(trainer => ({
          id: trainer.id.toString(),
          title: trainer.title,
        })) : []);

        setEventData(Array.isArray(trainingsData) ? trainingsData.map(event => ({
          id: event.ID.toString(),
          resourceId: event.resourceId.toString(),
          title: event.title.replace(/<br\/>/g, " ").trim(),
          start: event.start,
          end: event.end,
        })) : []);
      } else {
        throw new Error("Failed to fetch data from API");
      }
    } catch (error) {
      console.error("Error fetching training data:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <p class="position-absolute top-50 start-50 translate-middle text-center">
            <FaSpinner class="spinner" />
          </p>
    );
  }

  if (error) return <div className="alert alert-danger">Error loading calendar: {error}</div>;

  return (
    <div className="Container">
      <div id="formOne" className="rounded mt-2 bg-white">
        <TrainingCalenderfol
          initialDate={dateRange.start}
          resourceData={trainerData}
          eventData={eventData}
          aspectRatio={1.8}
          showHeader={true}
          onDatesChange={handleDatesChange}
        />
      </div>
    </div>
  );
};

export default TrainingCalender;